<div class="row mt-3 w-100">
  <app-dashboard-filters
    class="col-12"
    [solution]="selectedSolution"
    (changeSolution)="changeSolution($event)"
    [dateRange]="{ start: start, end: end }"
    (changeDate)="changeDate($event)"
    (changeUnit)="changeUnit($event)"
  ></app-dashboard-filters>

  @if (rights?.includes('UsageWidget')) {
    <app-system-usage
      class="col-sm-12"
      [solutionId]="selectedSolution"
      [start]="start"
      [end]="end"
      [selectedUnit]="selectedUnit"
    ></app-system-usage>
  }

  <app-case-usage
    class="col-12"
    [solutionId]="selectedSolution"
    [start]="start"
    [end]="end"
    [selectedUnit]="selectedUnit"
  ></app-case-usage>
</div>
